<template>
    <v-navigation-drawer
        expand-on-hover
        permanent
        mini-variant-width="60"
        width="200px"
        fixed
    >
        <template v-slot:prepend>
        <v-list>
            <v-list-item link to="/" class="avatar">
                <v-list-item-avatar>
                    <v-img src="http://launcher.evanyamoto.com/img/avatarshiba.png"></v-img>
                </v-list-item-avatar>
                <v-list-item-title>Home</v-list-item-title>
            </v-list-item>
        </v-list>
        </template>

        <v-divider></v-divider>

        <v-list
        nav
        dense
        >
            <v-list-item link to="/news">
                <v-list-item-icon>
                <v-icon>far fa-newspaper</v-icon>
                </v-list-item-icon>
                <v-list-item-title>News</v-list-item-title>
            </v-list-item>
            <v-list-item link to="/finance">
                <v-list-item-icon>
                <v-icon>fas fa-chart-line</v-icon>
                </v-list-item-icon>
                <v-list-item-title>Finance</v-list-item-title>
            </v-list-item>

            <v-divider></v-divider>

            <v-list-item link to="/sports">
                <v-list-item-icon>
                <v-icon>fas fa-football-ball</v-icon>
                </v-list-item-icon>
                <v-list-item-title>Sports</v-list-item-title>
            </v-list-item>
            <v-list-item link to="/cars">
                <v-list-item-icon>
                <v-icon>fas fa-car</v-icon>
                </v-list-item-icon>
                <v-list-item-title>Cars</v-list-item-title>
            </v-list-item>
            <v-list-item link to="/entertainment">
                <v-list-item-icon>
                <v-icon>fas fa-video</v-icon>
                </v-list-item-icon>
                <v-list-item-title>Entertainment</v-list-item-title>
            </v-list-item>

            <v-divider></v-divider>

            <v-list-item link to="/technology">
                <v-list-item-icon>
                <v-icon>fas fa-desktop</v-icon>
                </v-list-item-icon>
                <v-list-item-title>Technology</v-list-item-title>
            </v-list-item>
            <v-list-item link to="/development">
                <v-list-item-icon>
                <v-icon>fas fa-code</v-icon>
                </v-list-item-icon>
                <v-list-item-title>Development</v-list-item-title>
            </v-list-item>
            <v-list-item link to="/design">
                <v-list-item-icon>
                <v-icon>far fa-edit</v-icon>
                </v-list-item-icon>
                <v-list-item-title>Design</v-list-item-title>
            </v-list-item>

            <v-divider></v-divider>

            <v-list-item link to="/work">
                <v-list-item-icon>
                <v-icon>fas fa-briefcase</v-icon>
                </v-list-item-icon>
                <v-list-item-title>Work</v-list-item-title>
            </v-list-item>

        </v-list>
    </v-navigation-drawer>
</template>

<script>
export default {
  name: 'Sidebar'
}
</script>

<style lang="scss" scoped>

    .v-navigation-drawer--is-mouseover {
        .avatar {
            padding-left: 10px;
        }
        .v-avatar {
            margin-right: 20px !important;
        }
    }
</style>